export const PARAMETER_NAME_REGEX = /(?<=\${)[^{}]+(?=})/g;
export const EMPTY_PARAMETER_REGEX = /\$\{\s*\}/;
export const NESTED_PARAMETER_REGEX = /\$\{[^${}]*[${}]+[^${}]*\}/;
export const IMAGE_REGEX = /\\![\\w.]*\\!/;
export const HOUR_FORMAT_WITH_UNITS_REGEX = /(^(\d+)h?$)|(^(\d+)h\s+(\d+)m?$)|(^(\d+)m$)/;
export const HOURS_HOURS_REGEX = /(^(\d+):?$)|(^(\d+)(:|\s*)(\d+)$)/;
